export enum CovidTestStatus {
    pending = 1,
    verified = 2,
    rejected = 3
}